import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Pages/Home'
import Concept from '@/components/Pages/Concept'
import Contact from '@/components/Pages/Contact'
import Photos from '@/components/Pages/Photos'
import Faq from '@/components/Pages/Faq'
import Installation from '@/components/Pages/Installation'
import Videos from '@/components/Pages/Videos'
import Inox from '@/components/Pages/Inox'
import Modeles from '@/components/Pages/Modeles'
import Entretien from '@/components/Pages/Entretien'
import Mentions from '@/components/Pages/Mentions'
import Devis from '@/components/Pages/Devis'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: 'Garde-corps inox - Devis et calculateur de garde-corps inox | Oxynov',
        description: 'Bienvenue sur le site Oxynov, le premier site vous permettant de calculer le coût de votre devis de garde-corps en inox. Fabricant de garde-corps en kit prêts à monter, découvrez l\'ensemble des produits Oxynov.',
        keywords: 'Garde-corps inox, rambarde inox, balustrade inox, Garde-corps escalier, garde-corps en kit, garde-corps terrasse, protection inox, garde-corps verre, garde corps câble, garde-corps contemporain, garde-corps extérieur, protection escalier, protection terrasse, protection mezzanine, garde corps terrasse bois, garde corps balcon, rambarde terrasse, rambarde escalier, main courante bois, main courante inox , installateur garde corps, barrière inox, garde corps piscine, design inox, balcon inox, architecture inox, cable inox, tube inox, kit inox'
      }
    },
    {
      path: '/concept',
      name: 'Concept',
      component: Concept,
      meta: {
        title: 'Garde-corps sur mesure Oxynov, garde corps inox livré en kit prêt à installer | Oxynov',
        description: 'Découvrez le concept des garde-corps Oxynov, votre garde-corps inox livré prêt à installer. Composez votre garde-corps sur mesure à partir d\'éléments standards, livré pré-monté.',
        keywords: 'Garde-corps inox, rambarde inox, balustrade inox, Garde-corps escalier, garde-corps en kit, garde-corps terrasse, protection inox, garde-corps verre, garde corps câble, garde-corps contemporain, garde-corps extérieur, protection escalier, protection terrasse, protection mezzanine, garde corps terrasse bois, garde corps balcon, rambarde terrasse, rambarde escalier, main courante bois, main courante inox , installateur garde corps, barrière inox, garde corps piscine, design inox, balcon inox, architecture inox, cable inox, tube inox, kit inox'
      }
    },
    {
      path: '/modeles',
      name: 'Modeles',
      component: Modeles,
      meta: {
        title: 'Découvrez les modèles de garde-corps inox, main courante bois ou inox, remplissage tube ou câble | Oxynov',
        description: 'Notre gamme d\'éléments pour garde-corps inox vous permet de concevoir un garde-corps sur mesure avec une esthétique personnalisée, main courante en bois ou acier inox, remplissage par tubes inox ou câbles métalliques.',
        keywords: 'combinaisons, mains courante bois, main courante inox, garde-corps inox, garde corps main courante bois, remplissage, remplissage tube, remplissage cable, poteaux inox, fixation orientable, pontet de fixation, vis inox, manchon de raccord main courante, platine de fixation main courante, coude pour main courante, cable inox, pince coupante, tendeurs, tubes inox'
      }
    },
    {
      path: '/photos',
      name: 'Photos',
      component: Photos,
      meta: {
        title: 'Galerie photos garde-corps, réalisations de garde-corps en inox | Oxynov',
        description: 'Découvrez les photos de réalisations Oxynov, garde-corps inox au look contemporain et design pour terrasse, piscine, balcon, balustrade.',
        keywords: 'photos, realisations, images, garde-corps, chantiers, realisation, garde corps piscine, balcon, balustrade, rambarde, escalier, mezzanine, photo garde corps inox, photo inox'
      }
    },
    {
      path: '/installation',
      name: 'Installation',
      component: Installation,
      meta: {
        title: 'Kit garde-corps Oxynov, votre garde-corps inox sur mesure prêt à l\'installation | Oxynov',
        description: 'Découvrez la procédure d\'installation d\'un garde-corps inox Oxynov. Comment utiliser nos éléments standards (poteaux, main courante, remplissage...) pour monter votre garde-corps en kit prêt à installer',
        keywords: 'installation garde corps, montage garde corps, installation garde corps oxynov, plan 3d, plan 2d, prêt à installer, pré-monté, garde-corps pour escalier, garde corps rampant, outils de pose'
      }
    },
    {
      path: '/faq',
      name: 'Faq',
      component: Faq,
      meta: {
        title: 'Tout savoir sur les garde-corps et garde-corps inox, installation, montage, fixation | Oxynov',
        description: 'Vous vous posez des questions sur les garde-corps et garde-corps inox ? Consultez la foire aux questions Oxynov. Tout ce qu\'il faut savoir sur l\'installation, montage, fixation de votre garde-corps sur mesure.',
        keywords: 'faq, questions, conseil, achat, installation, montage, garde-corps, garde corps inox, types d\'inox, 316, 304, tva, construction garde corps, resistance, fixation poteaux de garde-corps'
      }
    },
    {
      path: '/videos',
      name: 'Videos',
      component: Videos,
      meta: {
        title: 'Vidéos de pose de garde-corps inox | Oxynov',
        description: 'Découvrez l\'ensemble de la gamme de garde-corps OXYNOV en vidéos, exemples de pose, installation des poteaux, pose du remplissage, finitions... Apprenez à installer un garde-corps Oxynov comme un véritable professionnel de l\'aménagement.',
        keywords: 'Vidéos installation balustrade'
      }
    },
    {
      path: '/entretien',
      name: 'Entretien',
      component: Entretien,
      meta: {
        title: 'L\'entretien d\'un garde-corps Inox - Produits d\'entretien inox | Oxynov',
        description: 'Découvrez les produits d\'entretien Innosoft et Innoprotect, spécialement étudiés pour le nettoyage et l\'entretien de votre garde-corps inox.',
        keywords: 'entretien,nettoyage,garde-corps,inox,nettoyer,entretenir,rouille,protection,corrosion'
      }
    },
    {
      path: '/mentions-legales',
      name: 'Mentions',
      component: Mentions,
      meta: {
        title: 'Mentions légales du site Oxynov',
        description: 'Les mentions légales',
        keywords: 'Mentions légales'
      }
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact,
      meta: {
        title: 'Contactez nous pour plus d\'informations | Oxynov',
        description: 'Contactez l\'équipe d\'oxynov pour plus d\'informations sur la gamme de garde corps inox.',
        keywords: 'contact'
      }
    },
    {
      path: '/inox-304-316',
      name: 'Inox',
      component: Inox,
      meta: {
        title: 'Quels sont les différents types d\'inox, Inox 304 et Inox 316 | Oxynov',
        description: 'Quels sont les différents types d\'inox et quelles diférences entre un inox 304 (milieux standards) et inox 316 (milieux agressifs et humides) ?',
        keywords: 'Inox,304,316,resistance,resistance, degradation,milieu agressif,rouille,milieu marin,humidité, corrosion'
      }
    },
    {
      path: '/devis-garde-corps',
      name: 'Devis',
      component: Devis,
      meta: {
        title: 'Devis de garde-corps inox, calculer le prix de votre garde-corps | Oxynov',
        description: 'Calculez le coût de votre projet de garde-corps. Grâce au calculateur Oxynov 3D, déterminez en quelques minutes le prix de votre garde-corps sur mesure.',
        keywords: 'devis, calculateur, prix, 3d, plan 3d, tarif, coût, montage garde-corps, prix garde-corps, calculer cout, garde corps inox, cout balustrade, cout rambarde, prix rambarde, prix garde coprs balcon'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js